<vw-page
  *ngIf="page"
  [page]="page"
  [alwaysFillNav]="true"
  [showDealerInformation]="true"
>
  <vw-page-header> </vw-page-header>

  <div class="not-found-page">
    <div class="container">
      <div class="row">
        <div class="col-md-10 mx-auto">
          <h1 *ngIf="title">
            {{ title }}
          </h1>
          <div *ngIf="body" [innerHTML]="body | safe: 'html'"></div>
        </div>
      </div>
    </div>
  </div>
</vw-page>
